import React from 'react';
import styled from 'styled-components';
import styles from './Header.module.css';
import { Link } from 'react-router-dom';

// Define the props interface for the styled component
interface UlProps {
  open: boolean;
}

// Styled component with typed props
const Ul = styled.ul<UlProps>`
  list-style: none;
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;

  @media (max-width: 991px) {
    transform: ${({ open }) => (open ? 'translateX(0)' : 'translateX(100%)')};
    position: fixed;
    top: 0;
    right: 0;
    height: 100vh;
    width: 250px;
    background-color: white;
    flex-direction: column;
    padding: 2rem;
    transition: transform 0.3s ease-in-out;
  }
`;

// Define the props interface for the component
interface RightNavProps {
  open: boolean;
}

const RightNav: React.FC<RightNavProps> = ({ open }) => {
  const navItems = [['Home'], ['Discover', 'Global Challenge', 'Our Solution', 'Achievments'], ['Contact'],]; //'Products', 'Media', 'Log In', 'Discover', 'Leadership',

  return (
    <div>
      <Ul key="RightNav" open={open} className={styles.navigation}>
        {navItems.map((item, index) => (
          <li key={index + "li"}>
            <Link key={index} to={item[0] === 'Home' ? '/' : `/${item[0].toLowerCase()}`} className={styles.navItem}>
              {item[0]}
            </Link>
            {item.length > 1 ? (
              <ul className={styles.dropdown}>
                {item.slice(1).map((subItem, subIndex) => (
                <li key={subIndex + "subLi"} className={styles.dropdownLi}>
                  <Link key={subIndex} to={`/${subItem.toLowerCase()}`} className={styles.navItem}>
                    {subItem}
                  </Link>
                </li>
              ))}
              </ul>) : null}
          </li>
        ))}
      </Ul>
    </div>
  );
};

export default RightNav;

